// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_7-0";
export var skeletonCard = "_7-1";